import { render, staticRenderFns } from "./BeneficiaryInfoTable.vue?vue&type=template&id=c303da5c&scoped=true"
import script from "./BeneficiaryInfoTable.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInfoTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/beneficiary_info_table.css?vue&type=style&index=0&id=c303da5c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c303da5c",
  null
  
)

export default component.exports